import {
  OBTENER_PEDIDOS,
  OBTENER_PEDIDOS_EXITO,
  OBTENER_PEDIDOS_ERROR,
} from "../types";

// cada reducer tiene su propio state
const initialState = {
  pedidos: [],
  error: false,
  errorMessage: null,
  loading: false,
};

function pedidosReducer(state = initialState, action) {
  switch (action.type) {
    case OBTENER_PEDIDOS:
      return {
        ...state,
        loading: action.payload,
      };
    case OBTENER_PEDIDOS_EXITO:
      return {
        ...state,
        loading: false,
        error: null,
        pedidos: action.payload,
      };
    case OBTENER_PEDIDOS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errorMessage: action.payload.message,
      };
    default:
      return state;
  }
}

export default pedidosReducer;
